export const services = {
  title: "Services Additionnels",
  subtitle: "Services complémentaires pour faciliter la vie scolaire de votre famille",
  transport: {
    title: "Taxi depuis Vigo",
    description: "Taxi depuis Vigo. Minimum de 4 places. Seul ce service exige un engagement de réservation pour tout le trimestre ; le tarif indiqué est mensuel.",
    roundTrip: "Aller-retour",
    roundTripPrice: "225€/mois"
  },
  earlyBirds: {
    title: "Garderie Matinale",
    schedule: "Service quotidien à partir de 8h15",
    monthly: "Mensuel",
    monthlyPrice: "75€",
    daily: "Jours uniques",
    dailyPrice: "7€",
    note: "* Prix par famille - Lundi à Vendredi inclus"
  },
  lunch: {
    title: "Cantine",
    description: "Déjeuner et collation du matin suivant un régime équilibré avec des produits biologiques et locaux",
    monthly: "5 jours/semaine",
    monthlyPrice: "195€",
    threeDays: "3 jours/semaine",
    twoDays: "2 jours/semaine",
    perMonth: "/mois",
    note: "Les forfaits cantine sont réservés et payés chaque mois. Choisissez 5, 3 ou 2 jours fixes par semaine. Ludothèque incluse jusqu’à 17h00 (vendredi jusqu’à 16h00). Journée ponctuelle : prévenir 48 heures à l’avance.",
    daily: "Jours uniques",
    dailyPrice: "15€",
    takeaway: {
      title: "Option à emporter",
      description: "Pour le même prix, vous pouvez également commander de la nourriture à emporter à tout moment entre 14h00 et 17h00. Le contenant est fourni par Gándara."
    }
  },
  ludoteca: {
    title: "Tardes Gándara",
    schedule: "Horaires: 14h00 à 17h00",
    description: "Déjeuner et ludothèque jusqu'à 17h00 (vendredi, 16h00), avec des forfaits de 5, 3 ou 2 jours par semaine",
    freeWith: "Voir les activités 2026-27 : horaires, activités et tarifs",
    options: [
      { label: "Cantine", price: "14:00 - 15:00" },
      { label: "Ludothèque", price: "15:00 - 17:00 (vendredi, 16:00)" }
    ],
    note: "* Informations et réservations par WhatsApp : 616 975 363"
  },
  contact: {
    title: "Intéressé par un service?",
    description: "Contactez-nous pour en savoir plus sur les détails et la disponibilité",
    button: "Réserver une visite"
  }
};
